import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { styled, useTheme } from '@mui/material/styles';

const steps = ['ログイン', '認証', '完了'];

const GradientConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 14,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: theme.custom?.gradient || theme.palette.primary.main,
    },
  },
}));

interface StepIconProps {
  active?: boolean;
  completed?: boolean;
  icon: React.ReactNode;
}

function GradientStepIcon({ active, completed, icon }: StepIconProps) {
  const theme = useTheme();
  const gradient = theme.custom?.gradient || theme.palette.primary.main;

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: '0.875rem',
        transition: 'all 0.3s ease',
        ...(active || completed
          ? {
              background: gradient,
              color: '#fff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            }
          : {
              backgroundColor: theme.palette.grey[300],
              color: theme.palette.grey[600],
            }),
      }}
    >
      {icon}
    </Box>
  );
}

export interface ClaimStepperProps {
  /** 現在のステップ (0: ログイン, 1: 認証, 2: 完了) */
  activeStep: number;
}

export function ClaimStepper({ activeStep }: ClaimStepperProps) {
  return (
    <Stepper activeStep={activeStep} alternativeLabel connector={<GradientConnector />} sx={{ mb: 4 }}>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(props) => <GradientStepIcon {...props} icon={index + 1} />}
            sx={{
              '& .MuiStepLabel-label': {
                mt: 1,
                fontSize: '0.75rem',
                fontWeight: 500,
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
